import { Component } from "@angular/core";
import { BACKOFFICE_LOGIN_SELECTOR } from "../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../base/base.component";

@Component({
    selector: BACKOFFICE_LOGIN_SELECTOR,
    styles: [],
    templateUrl: "backofficelogin.component.html"
})
export class BackofficeloginComponent extends BaseComponent {}
